exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n/* Ensure SweetAlert appears above the attachment modal */\n.swal2-container {\n    z-index: 999999 !important;\n}\n", ""]);

// exports
